/**
 * Numeric scores: max two decimal places (half-up). Used for chart data and as the
 * canonical rounding before display.
 */
export function roundToTwoDecimals(value) {
  if (value == null || value === '') return value;
  const n = Number(value);
  if (Number.isNaN(n)) return value;
  return Math.round(n * 100) / 100;
}

/**
 * Two-decimal display for My Results numeric scores (Likert-style KPIs).
 */
export function formatOwnResultNumber(value) {
  if (value == null || value === '') return '--';
  if (value === '--') return '--';
  const n = Number(value);
  if (Number.isNaN(n)) return String(value);
  return roundToTwoDecimals(n).toFixed(2);
}
